import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import emailMask from 'text-mask-addons/dist/emailMask'

const defaultCurrencyMaskOptions = {
  prefix: 'R$ ',
  suffix: '',
  placeholder: 'R$ 00,00',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: '.',
  allowDecimal: true,
  decimalSymbol: ',',
  decimalLimit: 2,
  integerLimit: 7,
  allowNegative: false,
  allowLeadingZeroes: false,
}

const Mask = (name: string) => {
  const currencyMask = createNumberMask({
    ...defaultCurrencyMaskOptions,
  })

  switch (name) {
    case 'CPF':
      return [
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ]
    case 'CEP':
      return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
    case 'UF':
      return [/[A-Z]/, /[A-Z]/]
    case 'CNPJ':
      return [
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '.',
        /\d/,
        /\d/,
        /\d/,
        '/',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
      ]
    case 'CURRENCY':
      return currencyMask
    case 'PASSWORD':
      return [/[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/]
    case 'PHONE_NUMBER':
      return [
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]
    case 'EMAIL':
      return emailMask
    case 'CREDIT_CARD_NUMBER':
      return [
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]
    case 'EXPIRATION_DATE':
      return [/\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    case 'DATE':
      return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
    case 'CRM':
      return (rawValue: string) => {
        const digits = rawValue.replace(/\D/g, '')

        const maskedValue = digits.slice(0, 6)

        return maskedValue.split('').map(() => /\d/)
      }
    case 'ONLY_NUMBERS':
      return (rawValue: string) => {
        const digits = rawValue.match(/\d/g) || []
        return digits.map(() => /\d/)
      }
    default:
      return null
  }
}

export default Mask
